import React, { useEffect, useRef } from 'react';

const CustomTrans: React.FC<{ text: string }> = ({ text }) => {
  const spanEl = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!spanEl || !spanEl?.current) return;

    spanEl.current.innerHTML = text;
  }, [spanEl.current]);

  return <span ref={spanEl} />;
};

export default CustomTrans;
